app.service('deliveryPointAutocomplete', function (deliveryPointLocation, console) {

	function setAutocomplete(autocompleteInput, setLocation, showEmptySearch) {
		const options = {
			componentRestrictions: { country: "pl" },
		};
		if (typeof google != "undefined") {
			const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, options);
			google.maps.event.addListener(autocomplete, 'place_changed', function () {
				const { geometry } = autocomplete.getPlace();
				if (!geometry || !geometry.location) {
					deliveryPointLocation.findPlaceByAddress($(autocompleteInput).val(), function (location, partialMatch, bounds) {
						if (location && !partialMatch) {
							setLocation(location, bounds);
						} else {
							showEmptySearch();
						}
					});
				} else {
					const location = geometry.location;
					const bounds = geometry.viewport;
					setLocation(location, bounds);
				}
			});
			$(autocompleteInput).keydown(function (event) {
				if (event.which == 13) {
					event.preventDefault();
				}
			});
		} else {
			setTimeout(function () {
				setAutocomplete(autocompleteInput, setLocation, showEmptySearch)
			}, 500);
			console.log('deliveryPointAutocomplete nie został załadowany')
		}
	}

	return {
		setAutocomplete
	};
});